<template>
    <div class="current-status">
        <QS-h4-title title="当前状态" />
        <div class="current-status-content">
            <!-- 当前状态信息展示和操作 -->
            <div class="status-info">
                <div class="status">
                    <i
                        :style="orderDetailIcon.style"
                        :class="orderDetailIcon.class"
                    >
                    </i>
                    <span class="status-text">{{ orderStatusList[orderDetail.status] }}</span>
                </div>
                <div class="status-desc">{{ orderDesc }}</div>
                <div class="status-operate">
                    <el-button
                      v-if="showContactButton"
                      @click="contactService"
                      type="minor">
                      联系出单员
                    </el-button>
                    <el-button
                      v-if="showModifySchemeButton"
                      @click="modifyScheme"
                      type="minor"
                    >
                    修改保险方案
                    </el-button>
                    <el-button
                      v-if="
                        orderDetail.status === ORDER_STATUS_MAP.WAIT_TO_PAY"
                      @click="showQrCodeDialog"
                      type="minor">立即支付</el-button>
                </div>
            </div>
            <insuranceCompanyList
              v-if="orderDetail.status !== ORDER_STATUS_MAP.SUCCESS"
              :list="orderDetail.insuranceCompareUnderwritingOrderVOList"
              :orderStatus="orderDetail.status"
            />
        </div>
        <modifySchemaDrawer
          :orderId="orderId"
          @submitSucc="emit('submitSucc')"
          ref="modifySchemaRef"
        />
        <ImageView
            v-if="imageView.show"
            :imgViewShow="imageView.show"
            :imgList="[imageView.img]"
            @closeImgView="imageView.show = false"
        />
    </div>
</template>

<script setup>
import { ref, computed, toRefs } from 'vue'
import { MessageBox } from '@qs/ui'
import modifySchemaDrawer from './modifySchemaDrawer.vue'
import insuranceCompanyList from './insuranceCompanyList.vue'

import ImageView from '@/components/UploadCommon/components/ImageView.vue'
import { ORDER_STATUS_MAP, UNDERWRITE_STATE, orderStatusList, orderDescList } from '../../enum'

const props = defineProps(['orderDetail', 'orderId'])
const emit = defineEmits(['submitSucc'])

const { orderDetail, orderId } = toRefs(props)

// 保司列表
const currentRow = ref(0)

const imageView = ref({
  show: false,
  img: '',
})

// 修改保险方案组件
const modifySchemaRef = ref(null)

// 图标展示
const orderDetailIcon = computed(() => {
  const errList = [ORDER_STATUS_MAP.UNDERWRITING_FAILED, ORDER_STATUS_MAP.QUOTED_FAILED]

  const waitList = [
    ORDER_STATUS_MAP.WAIT_FOR_FEEDBACK,
    ORDER_STATUS_MAP.CONFIRMING,
    ORDER_STATUS_MAP.WAIT_TO_PAY,
    ORDER_STATUS_MAP.CONFIRMED_FOR_UNDERWRITING,
    ORDER_STATUS_MAP.WAIT_PAY_CONFIRM,
  ]

  const successList = [ORDER_STATUS_MAP.SUCCESS]

  const fontSize = 'font-size: 16px;'

  if (errList.includes(Number(orderDetail.value.status))) {
    return {
      class: 'el-icon-circle-close',
      style: `${fontSize}color: #F56C6C`,
    }
  }

  if (waitList.includes(Number(orderDetail.value.status))) {
    return {
      class: 'el-icon-time',
      style: `${fontSize}color: #366CFF`,
    }
  }

  if (successList.includes(Number(orderDetail.value.status))) {
    return {
      class: 'el-icon-circle-check',
      style: `${fontSize}color: #67C23A`,
    }
  }

  return {
    class: 'el-icon-warning',
    style: fontSize,
  }
})

// 订单状态描述
const orderDesc = computed(() => {
  return orderDetail.value.inscFailReason
    ? orderDetail.value.inscFailReason : orderDescList[orderDetail.value.status]
})


// 展示联系出单员
const showContactButton = computed(() => {
  const list = [
    ORDER_STATUS_MAP.WAIT_FOR_FEEDBACK,
    ORDER_STATUS_MAP.WAIT_TO_PAY,
    ORDER_STATUS_MAP.SUCCESS,
  ]
  return !list.includes(orderDetail.value.status) && !orderDetail.value.inscFailReason
})

// 展示修改保险方案
const showModifySchemeButton = computed(() => {
  return ORDER_STATUS_MAP.QUOTED_FAILED === Number(orderDetail.value.status)
})

// 联系出单员
const contactService = () => {
  const { insuranceOperatorName, insuranceOperatorTelephone } = orderDetail.value
  let contactText = `
      <div style='text-align: center'>
          <div style='font-size: 14px; color: #000000; margin-bottom: 10px'>${insuranceOperatorName}</div>
          <div style='font-size: 18px; color: #366cfe'>${insuranceOperatorTelephone}</div>
      </div>
    `
  if (!insuranceOperatorName || !insuranceOperatorTelephone) {
    contactText = '无出单员信息，请联系车为家工作人员'
  }
  MessageBox.alert(
    contactText,
    '出单员信息', {
      confirmButtonText: '我知道了',
      dangerouslyUseHTMLString: true,
    },
  )
}

// 立即支付
const showQrCodeDialog = () => {
  const confirmCompanyItem =
    orderDetail
      .value
      .insuranceCompareUnderwritingOrderVOList.find(
        (item) => item.underwritingState === UNDERWRITE_STATE.SUCCESS,
      )
  MessageBox.alert(
    `<div style="text-align:center">
        <div style="font-size: 14px; color: #000000">请使用支付宝/微信进行支付</div>  
        <image 
          style='width: 200px; height: 200px; margin-top: 10px'
          src="${confirmCompanyItem.paymentUrl}"
        ></image>
    </div>`,
    '二维码支付',
    {
      confirmButtonText: '关闭',
      dangerouslyUseHTMLString: true,
    },
  )
}

// 修改保险方案
const modifyScheme = () => {
  modifySchemaRef.value.open()
}

const getSelectQuotationUrl = () => {
  return orderDetail.value.insuranceCompareUnderwritingOrderVOList[currentRow.value].quotationUrl
}

const getSelectQuotationId = () => {
  return orderDetail.value.insuranceCompareUnderwritingOrderVOList[currentRow.value].id
}

defineExpose({
  getSelectQuotationUrl,
  getSelectQuotationId,
})

</script>
<style lang="scss" scoped>
.status-info {
    text-align: center;
    padding: 20px 0 40px 0;
    .status-text {
        color:  rgba(0, 0, 0, 0.9);
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }
    .status-desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 22px;
        margin-bottom: 16px;
    }
}
.qr-code {
  .qr-code-image {
    width: 200px;
    height: 200px;;
  }
}
</style>
